/* One optional recommendation. No automatic additions; never touches checkout settings. */
(() => {
  if (window.sssCartRefinementReady) return;
  window.sssCartRefinementReady = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sss-add]');
    if (!button || button.disabled) return;
    const root = button.closest('[data-sss-cart]');
    if (!root) return;
    event.preventDefault();
    const error = button.parentElement.querySelector('.sss-upsell-error');
    button.disabled = true;
    button.textContent = 'Adding…';
    error.hidden = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(button.dataset.sssAdd), quantity: 1}]})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This item could not be added. Please try again.');
      // A full native refresh keeps cart totals, payment buttons and third-party apps in sync.
      window.location.reload();
    } catch (e) {
      error.textContent = e.message || 'Please check your connection and try again.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = 'Add to bag';
    }
  });
})();

/* Policies read from shared Shopify pages; no extra requests or cart changes. */
(() => {
  if (window.sssCartPolicyReady) return;
  window.sssCartPolicyReady = true;
  let opener;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sss-policy]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const dialog = link.closest('[data-sss-cart]')?.querySelector('[data-sss-policy-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const key = link.dataset.sssPolicy === 'returns' ? 'returns' : 'shipping';
      const content = dialog.querySelector('[data-sss-policy-content="' + key + '"]');
      if (!content?.textContent.trim()) return;
      event.preventDefault();
      dialog.querySelectorAll('[data-sss-policy-content]').forEach(el => { el.hidden = el !== content; });
      dialog.querySelector('[data-sss-policy-title]').textContent = key === 'returns' ? 'Returns & exchanges' : 'Shipping & delivery';
      opener = link;
      dialog.showModal();
      document.documentElement.classList.add('sss-policy-open');
      const body = dialog.querySelector('.sss-policy-dialog-body');
      body.scrollTop = 0;
      if (link.dataset.sssPolicy === 'protection') {
        const anchor = content.querySelector('[name="packageprotection"], [id="packageprotection"]');
        anchor?.scrollIntoView({block:'start'});
      }
      return;
    }
    const close = event.target.closest('[data-sss-policy-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('[data-sss-policy-dialog]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('[data-sss-policy-dialog]')) return;
    document.documentElement.classList.remove('sss-policy-open');
    if (opener?.isConnected) opener.focus();
  }, true);
})();

/* Cart presentation fixes shared by the full Shopping Bag and cart drawer. */
(() => {
  if (window.sssCartPresentationReady) return;
  window.sssCartPresentationReady = true;

  const style = document.createElement('style');
  style.id = 'sss-cart-presentation-fixes';
  style.textContent = `
    /* Square product thumbnails with the entire product visible. */
    .sss-cart #main-cart-items .cart-item__media-wrapper {
      aspect-ratio: 1 / 1 !important;
      height: auto !important;
      padding-bottom: 0 !important;
      overflow: hidden !important;
      background: #f6f6f4;
    }
    .sss-cart #main-cart-items .cart-item__media-wrapper > a {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
    }
    .sss-cart #main-cart-items .cart-item__image,
    .sss-cart #main-cart-items .cart-item__media-wrapper img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center !important;
    }
    .cart-drawer .cart-item__media {
      aspect-ratio: 1 / 1 !important;
      height: auto !important;
      padding-bottom: 0 !important;
      overflow: hidden !important;
      background: #f6f6f4;
    }
    .cart-drawer .cart-item__image,
    .cart-drawer .cart-item__media img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center !important;
    }

    /* Redo Checkout+ should read as an order-summary row, not a promotional card. */
    .sss-redo-summary-row {
      background: transparent !important;
      background-color: transparent !important;
      border: 0 !important;
      border-top: 1px solid rgb(var(--color-border)) !important;
      border-bottom: 1px solid rgb(var(--color-border)) !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      margin: 0 !important;
      padding: 1rem 0 !important;
      width: 100% !important;
      max-width: none !important;
      min-height: 0 !important;
      color: rgb(var(--color-foreground)) !important;
      font-family: inherit !important;
    }
    .sss-redo-summary-row * {
      box-shadow: none !important;
      font-family: inherit !important;
    }
    .sss-redo-summary-row img,
    .sss-redo-summary-row svg {
      max-height: 28px !important;
      width: auto !important;
    }
  `;
  document.head.appendChild(style);

})();
